module.exports = __webpack_public_path__ + "img/ic_redcar.389cd713.png";